module.exports = __webpack_public_path__ + "img/tintuc26.ff557866.png";